export default __webpack_public_path__ + "static/Graphik-Medium-Web-c5e5890f7786eb14a138c186a05bbc4c.svg";